<template>
  <div>
    <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
    >
    </EmailGrabberPopup>
    <section
      class="mx-[25px] mt-[50px] rounded-[19px] bg-[#ffc8000c] py-10 px-[30px] lg:px-[80px] md:rounded-[60px] lg:mx-auto lg:pt-[110px] xl:h-[1020px] xl:w-[1300px]"
    >
      <!-- heading -->
      <div>
        <h3 class="text-[#FFC800] font-bold text-sm text-center">
          BUILT FOR EVERYONE
        </h3>
        <h2
          class="headline text-center mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Built for creators and entrepreneurs.
        </h2>
      </div>
      <!-- TABS -->
      <div
        class="font-bold sm:flex text-[#292d34] text-lg mx-auto mt-10 lg:w-[775px] justify-between"
      >
        <div class="">
          <h3
            class="lg:pr-[45px] pr-[20px] cursor-pointer"
            v-on:click="toggleTabs(1)"
            v-bind:class="{ 'hover:ease-in': openTab !== 1, '': openTab === 1 }"
          >
            Course Creation
          </h3>

          <hr
            class="mt-[10px] ml-0 h-[5px] w-[125px] lg:w-[150px] rounded-full bg-[#FFC800]"
            v-bind:class="{
              'hidden ': openTab !== 1,
              'block ease-in-out duration-700': openTab === 1
            }"
          />
        </div>

        <div class="">
          <h3
            class="lg:pr-[45px] pr-[20px] cursor-pointer mt-[20px] lg:mt-0"
            v-on:click="toggleTabs(2)"
            v-bind:class="{ '': openTab !== 2, '': openTab === 2 }"
          >
            Coaching
          </h3>
          <hr
            class="mt-[10px] ml-0 h-[5px] w-[100px] lg:w-[100px] rounded-full bg-[#FFC800]"
            v-bind:class="{
              'hidden hover:block': openTab !== 2,
              'block ease-in-out duration-700': openTab === 2
            }"
          />
        </div>

        <div class="">
          <h3
            class="lg:pr-[45px] pr-[20px] cursor-pointer mt-[20px] lg:mt-0"
            v-on:click="toggleTabs(3)"
            v-bind:class="{ '': openTab !== 3, '': openTab === 3 }"
          >
            Influencer Marketing
          </h3>
          <hr
            class="mt-[10px] ml-0 h-[5px] w-[100px] lg:w-[200px] rounded-full bg-[#FFC800]"
            v-bind:class="{
              'hidden hover:block': openTab !== 3,
              'block: ease-in-out duration-700': openTab === 3
            }"
          />
        </div>

        <div class="">
          <h3
            class="lg:pr-[45px] pr-[20px] cursor-pointer mt-[20px] lg:mt-0"
            v-on:click="toggleTabs(4)"
            v-bind:class="{ '': openTab !== 4, '': openTab === 4 }"
          >
            Podcasting
          </h3>
          <hr
            class="mt-[10px] ml-0 h-[5px] w-[100px] lg:w-[100px] rounded-full bg-[#FFC800]"
            v-bind:class="{
              'hidden hover:block': openTab !== 4,
              'block ease-in-out duration-700': openTab === 4
            }"
          />
        </div>
      </div>
      <!-- COURSE CREATION CARD -->
      <div
        class="w-full mt-[45px] mx-auto gap-10"
        v-bind:class="{ hidden: openTab !== 1, 'lg:flex': openTab === 1 }"
      >
        <div class="text-center block lg:hidden">
          <video
            class="mx-auto lg:w-[700px] rounded-[20px]"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="$filters.media_path('/videos/creator-course-ui-com.mp4')"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="mt-[30px] lg:mt-0">
          <ul>
            <li class="flex">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/hosting-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">Host</h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Build any course from start to finish with highly customizable
                  modules that make course creation a breeze.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/upsell-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Upsell
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Add multiple course in one login, and give members options to
                  unlock paid programs with one click.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/track-progress-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Track Progress
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  See how students and members are progressing with deep
                  tracking and more.
                </p>
              </div>
            </li>
          </ul>

          <button
            @click="toggleGrabber('free', null)"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#ffc800] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#FFC8007e] transition ease-in hover:bg-[#ffbb00] active:bg-[#ffae00] dark:border-none mt-[75px]"
          >
            Get Started
          </button>
        </div>

        <div class="text-center hidden lg:block">
          <video
            class="mx-auto lg:w-[700px] rounded-[20px]"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="$filters.media_path('/videos/creator-course-ui-com.mp4')"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <!-- COACHING CARD -->
      <div
        class="w-full mt-[45px] mx-auto gap-10"
        v-bind:class="{ hidden: openTab !== 2, 'lg:flex': openTab === 2 }"
      >
        <div class="text-center block lg:hidden">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/online-courses-for-coaches-holistic-and-health.png'
              )
            "
            alt="Best way to monetize social media by moving followers OFF social media."
          />
        </div>

        <div class="mt-[30px] lg:mt-0">
          <ul>
            <li class="flex">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="
                    $filters.media_path(
                      '/images/everything-in-one-place-icon.svg'
                    )
                  "
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Everything In One Place
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Gather all your clients in one login and deliver coaching that
                  no-one else can offer.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/hand-out-your-domain.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Hand out your domain. Not Zoom’s
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Look more professional and conduct business from a custom
                  domain that represents your business.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/direct-contact-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Direct Contact
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Chat, and conduct 1-on-1 video calls with one click from your
                  dashboard. No more asking users to download anything. Just
                  login.
                </p>
              </div>
            </li>
          </ul>

          <button
            @click="toggleGrabber"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#ffc800] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#FFC8007e] transition ease-in hover:bg-[#ffbb00] active:bg-[#ffae00] dark:border-none mt-[75px]"
          >
            Get Started
          </button>
        </div>

        <div class="text-center hidden lg:block">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/online-courses-for-coaches-holistic-and-health.png'
              )
            "
            alt="Best way to monetize social media by moving followers OFF social media."
          />
        </div>
      </div>
      <!-- INFLUENCER MARKETING CARD -->
      <div
        class="w-full mt-[45px] mx-auto gap-10"
        v-bind:class="{ hidden: openTab !== 3, 'lg:flex': openTab === 3 }"
      >
        <div class="text-center block lg:hidden">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/sell-physical-products-in-your-online-course-platform.png'
              )
            "
            alt=""
          />
        </div>

        <div class="mt-[30px] lg:mt-0">
          <ul>
            <li class="flex">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/post-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">Post</h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Post the same way as on Facebook and other services to the
                  most valuable fans.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/link-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  One Link, Link Tree
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  No need for a link tree that has 20 different links to
                  content. Direct everyone to the member signup for up-to-date
                  happenings.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/deliver-content-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Deliver Exclusive Content
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Create highly engaging forms of content that is restricted on
                  other services. Make extended videos for more profit.
                </p>
              </div>
            </li>
          </ul>

          <button
            @click="toggleGrabber"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#ffc800] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#FFC8007e] transition ease-in hover:bg-[#ffbb00] active:bg-[#ffae00] dark:border-none mt-[75px]"
          >
            Get Started
          </button>
        </div>

        <div class="text-center hidden lg:block">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/sell-physical-products-in-your-online-course-platform.png'
              )
            "
            alt=""
          />
        </div>
      </div>
      <!-- PODCASTING CARD -->
      <div
        class="w-full mt-[45px] mx-auto gap-10"
        v-bind:class="{ hidden: openTab !== 4, 'lg:flex': openTab === 4 }"
      >
        <div class="text-center block lg:hidden">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/podcast-episode-list-in-community-site.png'
              )
            "
            alt=""
          />
        </div>

        <div class="mt-[30px] lg:mt-0">
          <ul>
            <li class="flex">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="
                    $filters.media_path('/images/monetize-podcast-icon.svg')
                  "
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Easily Monetize Podcasts
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Organize podcasts into groups to give some for free and charge
                  for others. Forget about links to Youtube. LINK TO YOU!
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/more-than-mp3s-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  More than MP3’s
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Dynamically display podcast episodes with full HD video
                  playback audiences won’t be able to get enough of.
                </p>
              </div>
            </li>
            <li class="flex mt-[50px]">
              <div class="w-[80px]">
                <img
                  loading="lazy"
                  class=""
                  :src="$filters.media_path('/images/shield-icon.svg')"
                  alt="Best way to monetize social media by moving followers OFF social media."
                />
              </div>

              <div class="w-[350px]">
                <h4 class="text-lg text-[#292d34] font-bold mt-[10px]">
                  Backup and Protect
                </h4>
                <p class="text-sm text-[#292d34] font-normal mt-[10px]">
                  Maintain hard backups of data, and never worry about
                  cancellation or demonetization.
                </p>
              </div>
            </li>
          </ul>

          <button
            @click="toggleGrabber"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#ffc800] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#FFC8007e] transition ease-in hover:bg-[#ffbb00] active:bg-[#ffae00] dark:border-none mt-[75px]"
          >
            Get Started
          </button>
        </div>

        <div class="text-center hidden lg:block">
          <img
            loading="lazy"
            class="mx-auto lg:w-[700px]"
            :src="
              $filters.media_path(
                '/images/podcast-episode-list-in-community-site.png'
              )
            "
            alt=""
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'yellow-section'
};
</script>

<script setup>
import { ref } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const openTab = ref(1);
const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);
const toggleTabs = (tabNumber) => {
  openTab.value = tabNumber;
};

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};
</script>

<styles>
</styles>
